import React from 'react';
import Head from 'next/head';
import cn from 'classnames';
import Layout from 'components/layout';
import style from './index.module.scss';
import TDK from 'components/tdk';
import Nav from 'components/product/relevance/nav';

const menu1 = [
  {
    name: '智能硬件',
    link: '/hardware',
  },
  {
    name: '软件客户端',
    link: '/client',
  },
];

const menu2 = [
  {
    name: '一体化4K终端',
    link: '/hardware/fullSceneTerminal',
  },
  {
    name: '小鱼云镜',
    link: '/hardware/cloudMirrorSystem',
  },
  {
    name: '大型终端',
    link: '/hardware/flagshipTerminal',
  },
  {
    name: '中型终端',
    link: '/hardware/mediumTerminal',
  },
  {
    name: '中小型终端',
    link: '/hardware/integratedTerminal',
  },
  {
    name: '智能会议平板',
    link: '/hardware/meetingBoard',
  },
  {
    name: '电视墙服务器',
    link: '/hardware/TVwall',
  },
];
interface Props {
  title: string;
  current: number;
  menuIndex?: string;
  children: React.ReactNode;
  customClass?: string;
  pageKey?: string;
}

const menus: { [key: string]: any } = {
  '1': {
    name: '云视频会议',
    menu: menu1,
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2,
  },
};
const Wrapper = ({ title, current, children, menuIndex = '1', customClass, pageKey }: Props) => {
  return (
    <Layout layoutClass={style.layout} headerClass={style.header}>
      {pageKey ? (
        <TDK pageKey={pageKey} />
      ) : (
        <Head>
          <title>
            {menus[menuIndex].name}-{title}
          </title>
        </Head>
      )}
      <section className={cn(style.main, customClass)}>
        <Nav menu={menus[menuIndex].menu} defaultIndex={current} type={menus[menuIndex].type || 1} />
        {children}
      </section>
    </Layout>
  );
};

export default Wrapper;
